import classNames from 'classnames'
import React from 'react'

export default function HorizontalDivider({className}) {
    return (
        <div className={classNames('w-full px-2 my-3 border-b',className)}></div>
    )
}
